import { resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "h3 text-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_loading = _resolveComponent("vue-loading")!
  const _component_ThoughtWrapper = _resolveComponent("ThoughtWrapper")!
  const _directive_dompurify_html = _resolveDirective("dompurify-html")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.topic)
      ? _withDirectives((_openBlock(), _createElementBlock("p", _hoisted_1, null, 512)), [
          [_directive_dompurify_html, _ctx.topic.title]
        ])
      : _createCommentVNode("", true),
    (_ctx.topic)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (!_ctx.thoughts.length)
            ? (_openBlock(), _createBlock(_component_vue_loading, {
                key: 0,
                loadingMessage: "Inhalt werden geladen..."
              }))
            : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.thoughts, (thought) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: thought.id
                }, [
                  _createVNode(_component_ThoughtWrapper, {
                    thoughtid: thought.id,
                    showBackButton: false
                  }, null, 8, ["thoughtid"])
                ]))
              }), 128))
        ], 64))
      : _createCommentVNode("", true)
  ]))
}